"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when an assignment field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class AssignmentBodyNotValidError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`assignment: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = AssignmentBodyNotValidError;
//# sourceMappingURL=AssignmentBodyNotValidError.js.map